const FAVICONS = {
    localhost: '/images/favicon-local.svg',
    test: '/images/favicon.svg',
    staging: '/images/favicon-development.svg',
    production: '/images/favicon.svg',
} as const;

type AppEnv = keyof typeof FAVICONS;

const getAppEnv = (): AppEnv => {
    const env = process.env.REACT_APP_ENV as AppEnv | undefined;

    return env && env in FAVICONS ? env : 'localhost';
};

export const applyFavicon = () => {
    const href = FAVICONS[getAppEnv()];

    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");

    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }

    link.href = href;
};
